import React, { useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'

export default function AllowanceType() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  let { data: allowanceTypes, isLoading } = useQuery(['allowance-type', debouncedValue && debouncedValue], () => getAllData('/allowance/types', { searchQuery: debouncedValue }))

  const queryClient = useQueryClient()

  let tmpArr = []
  if (!isLoading && allowanceTypes?.data?.length > 0) {
    allowanceTypes.data.map((item) => {
      return tmpArr.push([{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { type: 'IMAGE', image: item.image }, { value: item.description }, { value: formatDate(item.createdAt) }])
    })
  }

  const layoutProps = {
    heading: 'Manage Allowance Type',
    url: ROUTES.ADD_ALLOWANCE_TYPE,
    editUrl: 'edit-allowance-type/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // tempHeaders: tempHeaders,
    // tempHeaderData: [],
    // filename: 'moduleAdmins',
    // sampleName: 'sample_moduleAdmins',
    // sheetName: 'moduleAdmin',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('delete/allowanceType', id)
    }
    queryClient.invalidateQueries('allowance-type')
  }

  return (
    <CustomTableLayout
      tableHeadings={['Allowance Type Name', 'Image', 'Description', 'Created At']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      // handlePageChange={handleChange}
      // paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
